import React from 'react';
import Logo from "../../images/landing/logo.svg";

export default class ContactUs extends React.Component {
  render(){
    return (
      <section className="about-us section-center">
        <div className="section-center-wrapper">
          <div className="hero-block">
            <div>
              <img src={Logo} alt="logo" className="logo" />
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="info-block">
                <div className="info-block-inner">
                  <p>If you need to contact us for any reason, please email us at <a href='mailto:support@pharmacistexamprep.ie'>support@pharmacistexamprep.ie</a>. We would love to hear from you.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/informations/ContactUs.js